import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp, SectionHead } from "@/components/Reveal";
import DenimBand from "@/components/denim/DenimBand";

const BANNERS = [
    { id: "earth", name: "Earth Green", copy: "Earth-conscious denim for daily wear — dyed, woven and worn with intention.", img: "/img/urwan/BD0A8494.jpg", to: "/shop?line=earth" },
    { id: "active", name: "Active Orange", copy: "Stretch-engineered pieces for men in motion — commute, travel, after hours.", img: "/img/urwan/2J7A0630.jpg", to: "/shop?line=active" },
    { id: "vintage", name: "Vintage Red", copy: "Deep indigos and statement cuts for the office and after dark.", img: "/img/urwan/DSC00722.jpg", to: "/shop?line=vintage" },
];

export default function CapsuleBanners() {
    return (
        <DenimBand className="pb-24 pt-20 md:pb-32 md:pt-28" testid="capsule-band">
            <div className="mx-auto w-full max-w-[1400px] px-5 md:px-8 lg:px-10">
            <div className="flex flex-wrap items-end justify-between gap-6">
                <SectionHead eyebrow="The Capsule Collections" title="Three Lines. One Wardrobe." />
                <FadeUp>
                    <Link
                        to="/shop"
                        data-testid="capsule-view-all"
                        className="group hidden items-center gap-2 text-[11px] font-mono uppercase tracking-[0.25em] text-mute transition-colors hover:text-gold md:inline-flex"
                    >
                        View All
                        <ArrowRight size={14} className="text-gold transition-transform group-hover:translate-x-1" />
                    </Link>
                </FadeUp>
            </div>
            <div className="mt-14 grid gap-6 md:grid-cols-3">
                {BANNERS.map((b, i) => (
                    <FadeUp key={b.id} delay={i * 0.1}>
                        <Link
                            to={b.to}
                            data-testid={`capsule-card-${b.id}`}
                            className="group relative block h-[420px] overflow-hidden bg-elev md:h-[480px]"
                        >
                            <img
                                src={b.img}
                                alt={`${b.name} collection`}
                                loading="lazy"
                                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />
                            <div className="absolute inset-x-0 bottom-0 p-7">
                                <p className="text-[10px] font-mono uppercase tracking-[0.3em] text-gold">
                                    Capsule {String(i + 1).padStart(2, "0")}
                                </p>
                                <h3 className="mt-3 font-display text-2xl font-bold uppercase tracking-tight text-ink md:text-3xl">
                                    {b.name}
                                </h3>
                                <p className="mt-2 text-sm leading-relaxed text-mute">{b.copy}</p>
                                <p className="mt-5 inline-flex items-center gap-2 border-b border-gold/60 pb-1 text-[11px] font-mono uppercase tracking-[0.25em] text-gold">
                                    Shop Now
                                    <ArrowRight size={12} className="transition-transform duration-300 group-hover:translate-x-1.5" />
                                </p>
                            </div>
                        </Link>
                    </FadeUp>
                ))}
            </div>
            </div>
        </DenimBand>
    );
}
